'use client';

import { FormattedMessage, useIntl } from 'react-intl';
import { PostPreview } from '@/types/shared';
import CardGridSection from '@/components/CardGridSection';
import PressCard from '@/components/PressCard';

export default function PressReleasesSection({ pressReleases }: { pressReleases: PostPreview[] }) {
  const intl = useIntl();
  
  const cardMetadata = pressReleases?.map(({ title }) => ({
    title: decodeURI(title),
    ariaLabel: intl.formatMessage(
      { defaultMessage: 'Press release: {title}' }, 
      { title: decodeURI(title) }
    )
  }));

  return (
    <>
      <CardGridSection header={<FormattedMessage defaultMessage="Press room" />} cardMetadata={cardMetadata}>
        {pressReleases?.map(({ title, date, slug, status }: PostPreview, index) => (
          <PressCard cardType="press-release" title={decodeURI(title)} date={date} slug={slug} status={status} key={`${title}-${index}`} />
        ))}
      </CardGridSection>
    </>
  );
}
